export function createEmptyValue(diffValue: any): any {
  if (diffValue) {
    if (Array.isArray(diffValue)) {
      // Arrays new to have the same number of elements but contain only empty strings.
      return Array(diffValue.length).fill('');
    }
    if (typeof diffValue === 'string' || diffValue instanceof String) {
      return ' ';
    }
    // if object is empty display it as a blank line
    if (diffValue !== null && typeof diffValue === 'object') {
      return ' ';
    }
    // Empty boolean is by default false
    if (typeof diffValue === 'boolean') {
      return false;
    }
  }
  return null;
}
